<template>
	<div
		id="guide-config-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="guide-config-modal"
		@keyup.esc.stop.prevent="CloseModal()"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<GridLayout
					:sidebar-state="false"
					:reactive-sidebar="false"
				>
					<template #right-header>
						<div class="modal-header">
							<p class="title">
								GUIA
								{{ type === 'module' ? 'DO MÓDULO' : 'DA MODALIDADE' }}
							</p>
							<div class="close-container">
								<button
									type="button"
									class="btn btn-tool"
									data-dismiss="modal"
									@click="CloseModal()"
								>
									<i class="far fa-times mx-1 font-24"></i>
								</button>
							</div>
						</div>
					</template>
					<template #right-content>
						<div class="modal-body">
							<div class="w-full flex flex-col">
								<div class="w-full flex items-center gap-3">
									<label class="mb-0"> TIPO: </label>
									<span class="text-highlight"
										><b>{{ type === 'module' ? 'MÓDULO' : 'MODALIDADE' }}</b></span
									>
								</div>
								<div class="w-full flex items-center gap-3">
									<label class="mb-0"> NOME: </label>
									<span class="text-highlight">
										<b>{{ item.name }}</b></span
									>
								</div>
							</div>
							<form class="w-full mt-5">
								<p class="mb-3">TIPO DE FATURAMENTO</p>
								<div class="flex flex-col gap-3">
									<div
										v-for="billingType in billingTypes"
										:key="`billingType-${billingType.key}`"
									>
										<label
											class="mb-0"
											:class="{
												selected: billingType.selected,
											}"
											>{{ billingType.name.toUpperCase() }}</label
										>

										<div class="flex flex-col gap-2">
											<div
												v-for="guide in billingType.guides"
												:key="`guide-${guide.key}`"
												class="form-check form-check-inline ml-4"
											>
												<input
													:id="`guide-${guide.key}`"
													type="checkbox"
													:checked="guide.selected"
													@change="HandleSelect(billingType.key, guide.key)"
												/>
												<label
													:for="`guide-${guide.key}`"
													:class="{
														selected: guide.selected,
													}"
													>{{ guide.name.toUpperCase() }}</label
												>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</template>
					<template #right-footer>
						<div class="w-full flex items-center justify-between footer">
							<button
								type="button"
								class="btn btn-danger"
								@click="CloseModal()"
							>
								CANCELAR
							</button>
							<button
								type="button"
								class="btn btn-success"
								@click="SaveConfig()"
							>
								SALVAR
							</button>
						</div>
					</template>
				</GridLayout>
			</div>
		</div>
	</div>
</template>

<script>
	import modalMixin from '@/mixins/modal'
	import { mapGetters } from 'vuex'
	import { BILLING_TYPES } from '@/constants'
	import { useConfirmation, useError } from '@/composables'

	export default {
		name: 'GuideConfigModal',
		mixins: [modalMixin],
		props: {
			type: {
				type: String,
				required: true,
			},
			item: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				BILLING_TYPES: BILLING_TYPES,
				modalId: '#guide-config-modal',
				config: null,
				selectedGuide: [],
				billingTypes: [],
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		methods: {
			async GetConfig() {
				return window.api
					.call('post', '/get-guides-config', {
						organization_id: this.requester_selected_id,
						type: this.type,
						item_id: this.item.id,
					})
					.then(({ status, data }) => {
						if (status === 404) return
						if (status === 200) {
							data.guides_config.forEach(config => {
								const billingType = this.billingTypes.find(bt => bt.key === config.billing_type)
								if (!billingType) return

								const guide = billingType.guides.find(g => g.key === config.key)
								if (!guide) return

								guide.selected = true
								billingType.selected = true
							})
							return
						}

						useError('Erro ao buscar configurações da guia!')
						return
					})
			},
			async SaveConfig() {
				const selectedGuides = this.billingTypes.flatMap(billingType =>
					billingType.guides
						.filter(guide => guide.selected)
						.map(guide => ({
							billing_type: billingType.key,
							key: guide.key,
						}))
				)

				return window.api
					.call('post', '/save-guides-config', {
						organization_id: this.requester_selected_id,
						type: this.type,
						item_id: this.item.id,
						guides: selectedGuides,
					})
					.then(({ status }) => {
						if (status !== 200) {
							useError('ERRO AO SALVAR CONFIGURAÇÕES DA GUIA!')
							return
						}

						useConfirmation()

						this.CloseModal()
					})
			},
			HandleSelect(billingTypeKey, guideKey) {
				const billingType = this.billingTypes.find(billingType => billingType.key === billingTypeKey)
				if (!billingType) return

				const guide = billingType.guides.find(guide => guide.key === guideKey)
				if (!guide) return

				const currentState = guide.selected
				this.ClearBillingTypeSelection(billingType)
				if (currentState) return

				guide.selected = !guide.selected
				billingType.selected = billingType.guides.some(guide => guide.selected)
			},
			ClearBillingTypeSelection(billingType) {
				billingType.guides.forEach(guide => {
					guide.selected = false
				})
				billingType.selected = false
			},
			async Init() {
				this.billingTypes = Object.values(this.BILLING_TYPES).map(billingType => {
					return {
						...billingType,
						selected: false,
						guides: billingType.guides.map(guide => {
							return {
								...guide,
								selected: false,
							}
						}),
					}
				})
			},
		},
		async mounted() {
			this.OpenModal()
			await this.Init()
			await this.GetConfig()
		},
	}
</script>

<style lang="scss" scoped>
	#guide-config-modal {
		.modal-dialog {
			max-width: 65vw;

			.modal-content {
				width: 100%;
				height: 70vh;
				background-color: var(--elementsBackgroundColor);
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 3rem;
				border: 1px solid var(--newPrimaryBackgroundColor);
				border-radius: 0.375rem;
				overflow: hidden;

				.modal-header {
					width: 100%;
					display: flex;
					align-items: center;
					position: relative;

					p.title {
						width: 100%;
						font-size: 1.938rem;
						font-weight: 300;
						letter-spacing: 0.08em;
						text-align: center;
						text-transform: uppercase;
						margin-bottom: 0;
					}

					.close-container {
						position: absolute;
						right: 0;
						top: 50%;
						transform: translateY(-50%);

						.btn {
							background-color: var(--newPrimaryBackgroundColor);
							border: 1px solid var(--newPrimaryBackgroundColor);
							color: var(--newPrimaryColor);
							outline: none;
							border-radius: 0.3rem;
							transition: all 0.1s ease-in-out;

							display: flex;
							align-items: center;
							justify-content: center;
							padding: 0.3rem 0.6rem;

							&:hover {
								background-color: var(--newPrimaryHoverBackgroundColor);
								border-color: var(--newPrimaryHoverBackgroundColor);
								color: var(--newPrimaryHoverColor);
							}

							&:active {
								background-color: var(--newPrimaryActiveBackgroundColor);
								border-color: var(--newPrimaryActiveBackgroundColor);
								color: var(--newPrimaryActiveColor);
							}

							&.btn-tool {
								width: 2.25rem;
								height: 2rem;
							}
						}
					}
				}

				.modal-body {
					width: 100%;
					flex: 1;
					display: flex;
					flex-direction: column;
					align-items: center;
					padding: 1rem;
					font-size: 0.875rem;

					form {
						label {
							color: var(--newPrimaryInitialBackgroundColor);
						}

						.form-check {
							input ~ label:before {
								background-color: var(--inputBackgroundColor);
								border: 1px solid var(--inputBorderColor);
							}

							input:checked ~ label:after {
								background: var(--newPrimaryFocusBackgroundColor);
								color: var(--newPrimaryFocusColor);
							}
						}
					}

					.text-highlight,
					.selected {
						font-weight: 600;
						color: var(--newPrimaryFocusBackgroundColor);
					}
				}

				.footer {
					.btn {
						width: 8rem;
					}
				}
			}
		}
	}
</style>
